import { SelectableFeedFilterMe, FeedgroupSlug, SelectableFeedFilterFeedgroup } from 'interfaces/feed'
import { mentionize } from 'helpers/feedCommonHelpers'

export const FEED_POST_MAX_IMAGES_COUNT = 1
export const FEED_OWN_POST_COMPOSE_ID = 'postCompose'

export const YOUR_POSTS_FILTER: SelectableFeedFilterMe = {
  type: 'your-posts',
}

export const FEEDGROUPS_FILTERS: Record<FeedgroupSlug, SelectableFeedFilterFeedgroup> = {
  everyone: {
    type: 'feedgroup',
    slug: 'everyone',
  },
  followed_people: {
    type: 'feedgroup',
    slug: 'followed_people',
  },
  followed_tags: {
    type: 'feedgroup',
    slug: 'followed_tags',
  },
  followed_posts: {
    type: 'feedgroup',
    slug: 'followed_posts',
  },
}

export const UID_REGEX = /[0-9a-z]+(?:-[0-9a-z]+)+/

export const USERNAME_REGEX = /[0-9a-zA-Z._-]*/
export const USERNAME_VALIDATE_REGEX = new RegExp(`^${ USERNAME_REGEX.source }$`)

export const MENTION_REGEX = new RegExp(mentionize(USERNAME_REGEX.source))

export const TAG_NAME_REGEX = /[a-z0-9]+(?:[_-][a-z0-9]+)*/
export const TAG_REGEX = new RegExp(`#${ TAG_NAME_REGEX.source }`)
export const TAGS_REGEX = new RegExp(TAG_REGEX.source, 'gi')

export const LINK_REGEX = /\bhttps?:\/\/\S+|\bwww.\S+/
export const LINKS_REGEX = new RegExp(LINK_REGEX.source, 'gi')

export const DELIMITER_REGEX = /(?:^|\s)/

export const POST_HIGHLIGHT_REGEX = new RegExp(`${ LINK_REGEX.source }|${ TAG_REGEX.source }`, 'gi')

export const COMPOSE_MAX_LENGTH = 10000

export const CONTENT_REQUIRED_ERROR = -1001
export const TAG_REQUIRED_ERROR = -1002
export const WITH_DESCRIPTION_ERROR = -1003
export const NO_FEED_USER_ERROR = -1004

export const FEED_SUGGESTS_LIMIT = 10
export const FEED_POPULAR_TAGS_LIMIT = 10
export const FEED_TRENDING_TAGS_LIMIT = 5
